import * as React from 'react';

import * as styles from './PageLayout.css';

export const PageLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <main className={styles['main']}>{children}</main>;
};
